<template>
  <div class="site-status-excel-download-range-dialog">
    <v-card>
      <v-card-title>
        범위 선택
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="mb-3">
            최대 한 달까지의 데이터를 조회할 수 있습니다. 한 번에 16000개까지의 데이터만 내림차순으로 조회됩니다.
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="excelDownloadDateRange.startDate"
                label="시작일자"
                readonly
                required/>
            </v-col>
            <v-col>
              <v-text-field
                v-model="excelDownloadDateRange.endDate"
                label="종료일자"
                readonly
                required/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-date-picker v-model="excelDownloadDateRange.startDate" scrollable locale="ko-kr" :show-current="false"/>
            </v-col>
            <v-col>
              <v-date-picker v-model="excelDownloadDateRange.endDate" scrollable locale="ko-kr" :show-current="false"/>
            </v-col>
          </v-row>

          <v-row class="ma-5" justify="center">
            <v-btn text @click="setRangeFromNow(0, 0)">오늘</v-btn>
            <v-btn text @click="setRangeFromNow(1, 1)">어제</v-btn>
            <v-btn text @click="setRangeFromNow(7, 0)">최근 7일</v-btn>
            <v-btn text @click="setRangeFromNow('1', 0)">이번 달</v-btn>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="downloadExcel"><v-icon>fa-file-download</v-icon>&nbsp;엑셀 다운로드</v-btn>
        <v-btn text @click="closeDialog">취소</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'siteStatusExcelDownloadRangeDialog',
    props: {
      dialog: {
        type: Object,
        required: true
      },
      siteStatus: {
        type: Array,
        required: true
      },
      dateRange: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        excelDownloadDateRange: {
          startDate: '2019-11-20',
          startTime: '00:00:00',
          endDate: '2019-11-20',
          endTime: '23:59:59'
        }
      }
    },
    methods: {
      initRange() {
        this.excelDownloadDateRange.startDate = this.dateRange.startDate;
        this.excelDownloadDateRange.endDate = this.dateRange.endDate;
      },
      setRangeFromNow(fromSubtractAmount, toSubtractAmount) {
        let startMoment;
        if (typeof fromSubtractAmount === 'string') {
          startMoment = moment().date(Number(fromSubtractAmount));
        } else {
          startMoment = moment().subtract(fromSubtractAmount, 'days');
        }

        let endMoment;
        if (typeof toSubtractAmount === 'string') {
          endMoment = moment().date(Number(toSubtractAmount));
        } else {
          endMoment = moment().subtract(toSubtractAmount, 'days');
        }

        this.excelDownloadDateRange.startDate = startMoment.format('YYYY-MM-DD');
        this.excelDownloadDateRange.endDate = endMoment.format('YYYY-MM-DD');
      },
      rangeValidate(startTimestamp, endTimestamp) {
        if ((endTimestamp - startTimestamp) > 2764800000) {
          this.popupAlert('다운로드 범위는 한 달 이내로 지정해야 합니다.', 'red');
          return false;
        }

        if ((endTimestamp - startTimestamp) < 0) {
          this.popupAlert('시작 날짜는 종료 날짜보다 앞으로 지정해야 합니다.', 'red');
          return false;
        }

        return true;
      },
      downloadExcel() {
        const retryFuncBackup = this.downloadExcel.bind(this);

        const endTimestamp = moment(`${this.excelDownloadDateRange.endDate}T${this.excelDownloadDateRange.endTime}`).valueOf();
        const startTimestamp = moment(`${this.excelDownloadDateRange.startDate}T${this.excelDownloadDateRange.startTime}`).valueOf();

        if (!this.rangeValidate(startTimestamp, endTimestamp)) {
          return;
        }

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/siteStatus/${this.siteStatus[0].siteId}/_excel?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          },
          responseType: 'blob'
        };

        axios.get(targetUri, config)
          .then(result => {
            console.log('excel download');
            console.dir(result);
            let fileName = result.headers["content-disposition"].split("filename=")[1];
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE인 경우에
              window.navigator.msSaveOrOpenBlob(new Blob([result.data],
                {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                fileName);
            } else {
              const url = window.URL.createObjectURL(new Blob([result.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', result.headers["content-disposition"].split("filename=")[1]);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
            this.closeDialog();
          });
      },
      closeDialog() {
        this.dialog.excelDownloadRangeDialog = false;
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      }
    },
    mounted() {
      this.initRange();
    }
  }
</script>